import { Manufacturer } from './Manufacturer';
import { User } from './User';
import { WarrantyLabor } from './WarrantyLabor';
import { WarrantyPartsReplaced } from './WarrantyPartsReplaced';
import { WarrantyPhoto } from './WarrantyPhoto';

export interface Warranty {
  id: number;
  date: string | null;
  userId: number | null;
  manufacturerId: number | null;
  sellingDealerName: string | null;
  sellingDealerAddress: string | null;
  sellingCity: string | null;
  sellingState: string | null;
  sellingZip: string | null;
  customerName: string | null;
  customerAddress: string | null;
  customerCity: string | null;
  customerState: string | null;
  customerZip: string | null;
  model: string | null;
  serialNumber: string | null;
  datePurchase: string | null;
  dateFailure: string | null;
  acresHrsOperated: number | null;
  tractorMake: string | null;
  tractorModel: string | null;
  dateOfRepair: string | null;
  attachmentsAdded: string | null;
  description: string | null;
  statusId: number | null;
  creditNumber: string | null;
  creditAmount: number | null;
  filledOutByName: string | null;
  distributorName: string | null;
  statusChangeDate: string | null;
  returnPartsUps: boolean | null;
  returnPartsComercial: boolean | null;
  returnPartsCompanyTruck: boolean | null;
  filledOutByEmail: string | null;

  manufacturer: Manufacturer | null;
  // user: User | null;
  warrantyLabors: WarrantyLabor[] | [];
  warrantyPartsReplaceds: WarrantyPartsReplaced[] | [];
  warrantyPhotos: WarrantyPhoto[] | [];
}

export enum WarrantyStatusEnum {
  New = 1,
  Pending = 2,
  Approved = 3,
  Rejected = 4,
}

export enum WarrantyStatusStringEnum {
  'New' = 1,
  'Pending' = 2,
  'Approved' = 3,
  'Rejected' = 4,
}
